
import { SeoResult } from "./types";

export const generateMockSeoResult = (websiteUrl: string): SeoResult => {
  // Normalize the website URL for display
  const domain = websiteUrl.replace(/^https?:\/\//, '').split('/')[0];
  
  return {
    score: Math.floor(Math.random() * 30) + 50,
    metrics: [
      {
        title: "Meta Title",
        score: Math.floor(Math.random() * 30) + 70,
        status: "warning",
        suggestion: "Your title tag could be more optimized for your target keywords.",
      },
      {
        title: "Meta Description",
        score: Math.floor(Math.random() * 20) + 60,
        status: "warning",
        suggestion: "Your meta description is missing important keywords.",
      },
      {
        title: "Content Quality",
        score: Math.floor(Math.random() * 30) + 50,
        status: "bad",
        suggestion: "Your content is too thin compared to top-ranking competitors.",
      },
      {
        title: "Mobile Friendliness",
        score: Math.floor(Math.random() * 10) + 90,
        status: "good",
      },
      {
        title: "Page Speed",
        score: Math.floor(Math.random() * 40) + 50,
        status: "warning",
        suggestion: "Your page loads too slowly on mobile devices.",
      },
      {
        title: "Backlink Profile",
        score: Math.floor(Math.random() * 50) + 30,
        status: "bad",
        suggestion: "Your site has few quality backlinks compared to competitors.",
      },
      {
        title: "URL Structure",
        score: Math.floor(Math.random() * 20) + 70,
        status: "warning",
        suggestion: "Some URLs are not SEO-friendly with unnecessary parameters.",
      },
      {
        title: "Site Security",
        score: Math.floor(Math.random() * 15) + 85,
        status: "good",
      },
      {
        title: "Structured Data",
        score: Math.floor(Math.random() * 60) + 20,
        status: "bad",
        suggestion: "Missing schema markup that could enhance your SERP visibility.",
      },
      {
        title: "Internal Linking",
        score: Math.floor(Math.random() * 40) + 40,
        status: "warning",
        suggestion: "Poor internal linking structure weakens your page authority distribution.",
      },
    ],
    suggestions: [
      `Add more comprehensive content around your target keywords on ${domain}`,
      "Improve your page loading speed by optimizing images",
      "Build more high-quality backlinks from relevant websites",
      "Optimize your title tags with primary keywords near the beginning",
      "Add schema markup to enhance your search result appearance",
      "Implement a more consistent internal linking strategy",
      "Fix broken links throughout your website",
      "Improve mobile responsiveness on product pages",
      "Create dedicated landing pages for high-value keywords",
      "Optimize image alt tags with relevant keywords",
    ],
    keywords: [
      {
        keyword: "digital marketing agency",
        volume: 12100,
        difficulty: 67,
        position: 19,
        url: `${websiteUrl}/services`,
      },
      {
        keyword: "seo services",
        volume: 27700,
        difficulty: 72,
        position: 28,
        url: `${websiteUrl}/services/seo`,
      },
      {
        keyword: "content marketing strategy",
        volume: 8100,
        difficulty: 58,
        position: 12,
        url: `${websiteUrl}/services/content-marketing`,
      },
      {
        keyword: "ppc management",
        volume: 6600,
        difficulty: 64,
        position: 23,
        url: `${websiteUrl}/services/ppc`,
      },
      {
        keyword: "social media marketing agency",
        volume: 9400,
        difficulty: 69,
        position: 31,
        url: `${websiteUrl}/services/social-media`,
      },
    ],
    pages: [
      {
        url: `${websiteUrl}`,
        title: `Los Angeles SEO Group | Expert SEO & PPC Services for ${domain}`,
        metaDescription: `Award-winning digital marketing agency specializing in SEO, PPC, and content marketing for ${domain}. Drive more traffic and conversions with our proven strategies.`,
        h1Count: 1,
        wordCount: 1246,
        loadTime: "2.8s",
        internalLinks: 42,
        externalLinks: 7,
        images: 12,
        imagesWithAlt: 9,
        score: 76
      },
      {
        url: `${websiteUrl}/services/seo`,
        title: `SEO Services | Boost ${domain}'s Search Rankings`,
        metaDescription: `Our expert SEO services drive organic traffic and improve search rankings for ${domain}. Custom strategies for businesses of all sizes.`,
        h1Count: 1,
        wordCount: 1842,
        loadTime: "2.3s",
        internalLinks: 18,
        externalLinks: 4,
        images: 6,
        imagesWithAlt: 6,
        score: 84
      },
      {
        url: `${websiteUrl}/about`,
        title: `About ${domain} | Our Digital Marketing Story`,
        metaDescription: `Learn about ${domain}'s approach to online marketing and our story of helping businesses grow online.`,
        h1Count: 1,
        wordCount: 985,
        loadTime: "1.9s",
        internalLinks: 12,
        externalLinks: 2,
        images: 8,
        imagesWithAlt: 5,
        score: 69
      },
      {
        url: `${websiteUrl}/blog`,
        title: `${domain} Blog | Latest SEO & PPC Tips`,
        metaDescription: `Stay up-to-date with the latest digital marketing trends, tips, and strategies on the ${domain} blog.`,
        h1Count: 1,
        wordCount: 645,
        loadTime: "2.1s",
        internalLinks: 37,
        externalLinks: 9,
        images: 14,
        imagesWithAlt: 12,
        score: 72
      },
    ],
    backlinks: Math.floor(Math.random() * 1000) + 500,
    competitors: [
      {
        domain: "competitor1.com",
        score: 82,
        traffic: 124000,
        keywords: 6200,
        backlinks: 4700
      },
      {
        domain: "competitor2.com",
        score: 76,
        traffic: 98000,
        keywords: 5100,
        backlinks: 3200
      },
      {
        domain: "competitor3.com",
        score: 69,
        traffic: 76000,
        keywords: 4300,
        backlinks: 2800
      },
    ],
    dataSource: "This is a simulated analysis for demonstration purposes only. For a real SEO audit with accurate data from professional tools like Ahrefs, SEMrush, and Moz, please contact Los Angeles SEO Group for a comprehensive analysis."
  };
};
